module.exports = __webpack_public_path__ + "img/skull_11.edeee2ce.png";